import * as z from "zod"

export const attachmentSchema = z.discriminatedUnion("attached", [
  z.object({
    attached: z.literal(false),
    signed_id: z.null().optional(),
    attachment: z.instanceof(FileList).optional(),
  }),
  z.object({
    attached: z.literal(true),
    signed_id: z.string(),
    filename: z.string(),
    url: z.string(),
  }),
])
